import { httpV2 } from "../http";

const SeamService = {
  getSettings: () => httpV2.get("/seam/settings"),
  updateSettings: (data) => httpV2.put("/seam/settings", data),
  createPortal: () => httpV2.post("/seam/portal"),
  syncSpaces: () => httpV2.post("/seam/sync-spaces"),
  syncReservations: () => httpV2.post("/seam/sync-reservations"),
  getAccessCodes: (reservationId) =>
    httpV2.get(`/seam/access-codes/${reservationId}`),
  getLogs: (reservationId) =>
    httpV2.get(`/seam/logs/${reservationId}`),
};

export default SeamService;
